import { User, UserManagerSettings } from "oidc-client-ts";
import { createContext, useContext } from "react";

type OIDCClientSettings = UserManagerSettings & {
  onSigninCallback?: (user: User | void) => Promise<void> | void;
};

const OIDCSettings: OIDCClientSettings = {
  authority: `${import.meta.env.VITE_AUTH_BASE_URL}/auth/realms/${
    import.meta.env.VITE_REALM
  }`,
  client_id: `${import.meta.env.VITE_CLIENT_ID}`,
  redirect_uri: `${window.location.origin}/auth/callback`,
  silent_redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: window.location.origin,
  automaticSilentRenew: true,
  scope: "email openid",
  revokeTokensOnSignout: true,
};

/**
 * Static configs for OAuth Identity
 */
export const OIDCSettingsContext = createContext(OIDCSettings);

export function useOIDCSettings(): OIDCClientSettings {
  const settings = useContext(OIDCSettingsContext);

  return {
    ...settings,
    onSigninCallback: () => {
      window.history.replaceState(null, "", window.location.origin);
    },
  };
}
